var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvalanche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avalanche (AVAX)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Avalanche (AVAX)_2",
    cx: 24,
    cy: 24.5,
    r: 24,
    fill: "#E84142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Avalanche (AVAX)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.436 7.62441C24.6045 6.18819 23.2817 6.18819 22.4502 7.62441L7.35097 34.2134C6.51947 35.6685 7.19979 36.8213 8.86278 36.8213H16.4407C17.9714 36.7268 19.351 35.9142 20.1825 34.6291L29.31 18.8118C29.9714 17.4512 29.9714 15.8449 29.31 14.4842L26.5888 9.70315L25.436 7.62441ZM35.4708 25.1236C34.6393 23.6874 33.2976 23.6874 32.4661 25.1236L27.1936 34.2134C26.381 35.6496 27.0614 36.8213 28.7055 36.8213H39.1369C40.7999 36.8213 41.4803 35.6496 40.6488 34.2134L35.4708 25.1236Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/Avalanche.557651c0a08c164cc1248bd3d4d0d1a8.svg";
export { ForwardRef as ReactComponent };